import React from "react";

const SliderRound = ({ checked, onChange, id, name }) => (
  <label className="switch">
    <input
      type="checkbox"
      checked={checked}
      onChange={onChange}
      id={id}
      name={name}
    />
    <span className="slider round"></span>
    <style>{`
      .switch {
        position: relative;
        display: inline-block;
        width: 64px;
        height: 40px;
      }
      .switch input {
        opacity: 0;
        width: 0;
        height: 0;
      }
      .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #111221;
        -webkit-transition: .4s;
        transition: .4s;
        border-radius: 40px;
      }
      .slider:before {
        position: absolute;
        content: "";
        height: 32px;
        width: 32px;
        left: 4px;
        bottom: 4px;
        background-color: white;
        -webkit-transition: .4s;
        transition: .4s;
        border-radius: 50%;
      }
      input:checked + .slider {
        background-color: #69D658;
      }
      input:checked + .slider:before {
        -webkit-transform: translateX(24px);
        -ms-transform: translateX(24px);
        transform: translateX(24px);
      }
    `}</style>
  </label>
);

export default SliderRound;
